import axios from "axios";

//const API = axios.create({ baseURL: process.env.VUE_APP_URL || "" });
const API = axios.create({
  baseURL: "https://sipavi.aevivienda.gob.bo/api/" || "",
});

export function getConfig(token) {
  return { headers: { Token: token } };
}

export function getPaises(token) {
  return API.get("pais/list", getConfig(token));
}
export function getDepartamentos(token) {
  return API.get("departamento/list", getConfig(token));
}
export function getTransporte(token) {
  return API.get("transporte/list", getConfig(token));
}
export function getUnidad(token) {
  return API.get("unidad/list", getConfig(token));
}
export function getFinanciamiento(token) {
  return API.get("financiamiento/list", getConfig(token));
}
export function getRegionNacional(token) {
  return API.get("region_nacional/list", getConfig(token));
}
export function getRegionInternacional(token) {
  return API.get("region_internacional/list", getConfig(token));
}
export function getLineaAerea(token) {
  return API.get("linea_aerea/list", getConfig(token));
}
export function getResolucion(token) {
  return API.get("resolucion/list", getConfig(token));
}
export function getUsuario(id, token) {
  return API.get(`usuario/query/${id}`, getConfig(token));
}
export function getViajesPorUnidad(unidad, token) {
  return API.get(`viaje/list/${unidad}`, getConfig(token));
}
export function getViajeUsuario(id, token) {
  return API.get(`usuario/query/${id}`, getConfig(token));
}
export function downloadArchivo(id, token) {
  // return axios.get(
  //   `https://sipavi.aevivienda.gob.bo/api/viaje/filedownload/${id}`,
  //   getConfig(token),
  // );
  return API.get(`viaje/filedownload/${id}`, getConfig(token));
}
export function addViaje(data, token) {
  return API.post("viaje/add", data, getConfig(token));
}
export function updateViaje(id, data, token) {
  return API.put(`viaje/update/${id}`, data, getConfig(token));
}
export function addPresupuesto(data, token) {
  return API.post("pasaje/add", data, getConfig(token));
}
export function updatePresupuesto(id, data, token) {
  return API.put(`pasaje/update/${id}`, data, getConfig(token));
}
export function addLiquidacion(data, token) {
  return API.post("liquidacion/add", data, getConfig(token));
}
export function cancelarViaje(id, data, token) {
  return API.put(`viaje/updateEstado/${id}`, data, getConfig(token));
}
